import { useState, useRef, useEffect } from "react";
import axios from "axios";
 
const Chatbot = () => {
  const [messages, setMessages] = useState([
    { sender: "bot", text: "Hi! How can I assist you today?" },
  ]);
  const [input, setInput] = useState("");
  const chatContainerRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
 
  const validatePincode = async (pincode) => {
    try {
      const response = await axios.get(`https://api.postalpincode.in/pincode/${pincode}`);
      return response.data[0].Status === "Success";
    } catch (error) {
      console.error("Error validating pincode:", error);
      return false;
    }
  };
 
  useEffect(() => {
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
    }
  }, [messages]);
 
  const sendMessage = async () => {
    if (!input.trim()) return;
 
    const userMessage = { sender: "user", text: input };
    setMessages((prev) => [...prev, userMessage]);
    setInput("");
 
    let apiType = "unbxd";
    const pinRegex = /\b\d{6}\b/;
    const match = input.match(pinRegex);
 
    if (match) {
      const pincode = match[0];
      const isValidPin = await validatePincode(pincode);
      if (isValidPin) {
        apiType = "node";
      }
    }
 
    try {
      const response = await axios.post(
        "https://obl-js.orientbell.com/api/chatbot",
        { message: input, apiType },
        { headers: { "Content-Type": "application/json" } }
      );
 
      const newMessages = [];
      if (response.data.reply) {
        newMessages.push({ sender: "bot", text: response.data.reply });
      }
 
      if (response.data.products && Array.isArray(response.data.products)) {
        const products = response.data.products.slice(0, 5);
        newMessages.push({ sender: "bot", products });
      }
 
      setMessages((prev) => [...prev, ...newMessages]);
    } catch (error) {
      console.error("Error fetching response:", error);
      setMessages((prev) => [
        ...prev,
        { sender: "bot", text: "Sorry, I couldn't process that." },
      ]);
    }
  };
 
  return (
    <div className="fixed bottom-5 right-5">
      {/* Chatbot Toggle Button */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="chatbot-icon-bx"
      >
        <img src='/cbot.jpg'></img>
      </button>
 
      {/* Chat Window */}
      {isOpen && (
        <div className="chatbot-date-bx">
          {/* Header */}
          <div className="chatbot-header-row">
            <span><img src="https://server.orientbell.com/media/img/logo-white.png"></img></span>
            <button onClick={() => setIsOpen(false)} className="chatbot-close">✖</button>
          </div>
 
          {/* Chat Messages */}
          <div ref={chatContainerRef} className="chatbt-chat-bx">
            {messages.map((msg, index) => (
              <div key={index} className=" chatbot-chat-sec">
                {msg.text && (
                  <div
                    className={`chatbot-common ${
                      msg.sender === "user"
                        ? "right"
                        : "chatbot-chat-left"
                    }`}
                  >
                    {msg.text}
                  </div>
                )}
 
                {msg.products && (
                  <div className="chatbot-product-grid">
                    {msg.products.map((product, i) => (
                      <div
                        key={i}
                        className="chatbot-product-col"
                      >
                        <img
                          src={product.image_url[0]}
                          alt={product.name}
                          className="w-full h-[120px] object-cover rounded-md"
                        />
                        <div className="chatbot-pro-text-bx">
                          <h3 className="text-sm font-semibold text-gray-900 truncate">{product.name}</h3>
                          <p className="text-xs text-gray-600 mt-1">{product.price}</p>
                          <a
                            href={product.url_key}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-xs font-medium text-blue-500 hover:underline"
                          >
                            View →
                          </a>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
 
          {/* Input Box */}
          <div className="chatbot-input-row">
            <input
              type="text"
              value={input}
              onChange={(e) => setInput(e.target.value)}
              className="flex-1 p-2 border rounded-l-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
              placeholder="Type a message..."
            />
            <button
              onClick={sendMessage}
              className="bg-blue-600 text-white px-4 py-2 rounded-r-lg hover:bg-blue-700 transition text-sm"
            >
              Send
            </button>
          </div>
        </div>
      )}
    </div>
  );
};
 
export default Chatbot;
 
 